import React from "react";
import "./Trainers.css";
const TrainersHead = () => {
  return (
    <div className="trainersHeadContainer">
      <h2>
        Certified Trainers Offering <span>German</span> Classroom Sessions
      </h2>
      <p>
        Join our German classroom sessions at Prizma Academy, taught by highly
        qualified teachers. Learn individually or with a group of fellow German
        learners.
      </p>
    </div>
  );
};

export default TrainersHead;
